
<div
  class="resource-icon"
  [ngClass]="[
  emphasizeText ? 'emphasis' : '',
  angryColorWhenQuantityExceedsMax && maxQuantity >= 0 && quantity > maxQuantity ? 'angry' : (rarity || 'Common'),
  name === 'nothing' ? 'nothing' : ''
]">
  <app-game-icon class="icon" [icon]="icon" [inlineIconSize]="inlineIconSize"></app-game-icon>

  <span class="name" *ngIf="resource && resource.internalId" [ngxTippy]="tooltip">
    <app-real-name [name]="resource.internalId"></app-real-name>
  </span>

  <span class="quantity" *ngIf="quantity >= 0">
    {{ showX ? 'x' : '' }}{{ quantity | number }}<span *ngIf="!maxIsNotImportant">{{ maxQuantity >= 0 ? '/' + (maxQuantity | number) : '' }}</span>
  </span>

  <ng-template #tooltip>
    <app-resource-tooltip *ngIf="resource" [resource]="resource" [showQuantity]="true"></app-resource-tooltip>
  </ng-template>
</div>
